import { observable, keys } from "mobx"

import {
  Session
} from '../types';

const session: Session = observable.object({success: false, csrftoken: ''});

function setSession(newSession: Session) {
  if (session.success !== newSession.success) session.success = newSession.success;
  if (session.csrftoken !== newSession.csrftoken) session.csrftoken = newSession.csrftoken;
  if (session.student !== newSession.student) session.student = newSession.student;
  return session;
}

function getSession() {
  return session;
}

export {
  setSession,
  getSession
}